import { render, staticRenderFns } from "./ProductsListViewSB.vue?vue&type=template&id=5931aa29&scoped=true"
import script from "./ProductsListViewSB.vue?vue&type=script&lang=js"
export * from "./ProductsListViewSB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5931aa29",
  null
  
)

export default component.exports